import LegalDocViewer from "@/components/LegalDocViewer";
import content from "@/legal-rendered/dpa";

export default function DPAPage() {
  return (
    <LegalDocViewer
      title="Data Processing Addendum"
      subtitle="B2B + vendor data processing addendum"
      policyId="dpa"
      policyVersion="1.1.0"
      content={content}
    />
  );
}
